/**
 * i18n hooks wrapper
 * Centralizes react-i18next imports for consistent translation handling across the app
 */

import { useTranslation as useI18nTranslation } from 'react-i18next';

export { Trans, Translation } from 'react-i18next';

export function useTranslation(ns?: string | string[]) {
  return useI18nTranslation(ns);
}

export type TFunction = ReturnType<typeof useI18nTranslation>['t'];
